import React, {
  useState,
  useEffect
} from 'react';

import { Form, Field } from "react-final-form";

import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Collapse,
  Badge,
  Button,
  IconButton,
  ListSubheader,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  StepContent,
  Typography,
  Tooltip,
  colors,
  ButtonBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Grid,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  InputLabel,
  MenuItem,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Snackbar,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import {
  DateTimeView,
  DocumentView,
  ProfileChip,
  FileUploadField,
} from '../../general';

import {
  Thesis,
  AdminNote,
} from '../../../types';

import localization from '../../../utils/localizations';
import {
  BaseAPI,
} from '../../../data/BaseAPI';

const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  table: {

  },
  rowNumber: {
    fontWeight: 'bold',
    color: '#cecece',
  },
  itemMargin: {
    marginRight: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  formContainer: {
    marginTop: 20,
  },
  mainGrid: {
    marginTop: 20,
    paddingRight: 10,
  },
  gridLabel: {
    textAlign: 'right',
    color: '#555555',
  },
  form: {
    margin: 20,
  },
  alignRight: {
    textAlign: 'right',
  },
}));


function AdminNotes(props: {
  notes: AdminNote[];
  hideNumber?: boolean;
  style?: any;
}) {
  const classes = useStyles();
  const [editNote, setEditNote] = useState(undefined as undefined|AdminNote);

  useEffect(() => {
    
  }, [props.notes]);

  return (
    <Paper className={classes.mainBody} style={props.style}>
      <TableContainer className={classes.table}>
        <Table className={classes.table} aria-label="notes">
          <TableHead>
            <TableRow>
              {!props.hideNumber && <TableCell></TableCell>}
              <TableCell>{localization.note}</TableCell>
              <TableCell align="right">{localization.date}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.notes.map((note, i) => {
              
              return (
                <TableRow key={`shared-doc-${note.id}`}>
                  {!props.hideNumber && <TableCell><span className={classes.rowNumber}>{(i+1)}</span></TableCell>}
                  <TableCell component="th" scope="row" style={{minWidth: 210}}>
                    <div><b>{note.title}</b></div>
                    <div style={{whiteSpace: 'pre-line'}}>{note.content}</div>
                  </TableCell>
                  <TableCell align="right">
                    <DateTimeView value={note.updated_at} />
                  </TableCell>
                </TableRow>
              );
            })}
            {props.notes.length === 0 &&
              <TableRow>
                <TableCell colSpan={3}>{localization.noNotesYet}</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export {AdminNotes};
